/** @format */

import React, { PureComponent, Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withSnackbar } from 'notistack';
import { notificationActions as NotificationHelper, notificationActions } from '../modules/notifications/actions';
import notificationReducers from '../modules/notifications/reducers';
import i18n from './i18n';

class Notifier extends Component {
    displayed = [];

    storeDisplayed = (id) => {
        this.displayed = [...this.displayed, id];
    };

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        if (!nextProps.reducers || !nextProps.reducers.notifications) {
            return false;
        }

        const newSnacks = nextProps.reducers.notifications;

        if (!newSnacks.length) {
            this.displayed = [];
            return false;
        }

        const { notifications: currentSnacks } = this.props.reducers;

        let notExists = false;
        for (let i = 0; i < newSnacks.length; i += 1) {
            const newSnack = newSnacks[i];
            if (newSnack.dismissed) {
                this.props.closeSnackbar(newSnack.key);
                NotificationHelper.removeSnackbar(newSnack.key);
            }

            if (notExists) {
                continue;
            }
            notExists = notExists || !currentSnacks.filter(({ key }) => newSnack.key === key).length;
        }
        return notExists;
    }

    componentDidUpdate() {
        let notifications = [];
        if (this.props.reducers && this.props.reducers.notifications) {
            notifications = this.props.reducers.notifications;
        }

        notifications.forEach(({ key, message, options = {} }) => {
            if (this.displayed.includes(key)) {
                return;
            }
            this.props.enqueueSnackbar(message, {
                ...options,
                onClose: (event, reason, key) => {
                    if (options.onClose) {
                        options.onClose(event, reason, key);
                    }
                    // Dispatch action to remove snackbar from redux store
                    NotificationHelper.removeSnackbar(key);
                },
            });
            // Keep track of snackbars that we've displayed
            this.storeDisplayed(key);
        });
    }

    render() {
        return <div />;
    }
}

const mapStateToProps = (state) => {
    const { notificationReducers } = state;
    if (notificationReducers) {
        return {
            reducers: notificationReducers,
        };
    }
};

export default withSnackbar(connect(mapStateToProps)(Notifier));
